import { defineMessages } from 'react-intl';

export default defineMessages({
  addFileLevelCommentToolTip: {
    id: 'frontbucket.repository.pullRequest.addFileLevelCommentToolTip',
    description:
      'Description for the tooltip when adding a file-level comment.',
    defaultMessage: 'Add comment',
  },
  addFileLevelCommentButtonLabel: {
    id: 'frontbucket.repository.pullRequest.addFileLevelCommentButtonLabel',
    description: 'Accessibility text label for add file-level comment icon',
    defaultMessage: 'Add file-level comment',
  },
});
